var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 5.7a4.8 4.8 0 0 0-3.161 1.503c-1.3 1.341-2.2 2.103-3.799 1.456-1.5-.57-.24-2.542-2-3.397C9.895 4.707 9.735 2.992 10.373 2M2 11c1.362.662 1.83 1.269 3.088 1.269 2.6 0 3.12.496 3.12 2.483s0 1.987.52 3.477c.338.97.456 1.939-.218 2.771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19.9 19.928 22 22m-1.49-4.954c0 2.234-1.216 4.046-3.455 4.046A4.05 4.05 0 0 1 13 17.046 4.05 4.05 0 0 1 17.055 13c2.239 0 3.454 1.81 3.454 4.046Z"
  })));
};
export default SvgSearch;